import { BlocksIconTask } from 'blocks-nextjs/blocks-web-components/components/icon/icons/task';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconTask = createComponent({ react: React, tagName: 'cat-icon-task', elementClass: BlocksIconTask });
